import { createAsyncThunk } from "@reduxjs/toolkit";
import { del, get, patch, post } from "../../Services/ApiBase";
import { API_ENDPOINTS } from "../../Services/ApiEndPoints";
import { getApiErrorMessage } from "../../utils/apiErrorMessage";

const VENDOR_MAPPING = "VENDOR_TO_ACCOUNTING";

/**
 * List vendor → accounting tag mappings
 */
export const fetchVendorTagMappings = createAsyncThunk(
  "vendorTagMapping/fetchData",
  async (params = {}, { rejectWithValue }) => {
    try {
      const query = {
        mappingType: VENDOR_MAPPING,
        activeOnly: params.activeOnly === false ? false : true,
        ...params,
      };
      const response = await get(API_ENDPOINTS.TAG_MAPPINGS.GET_ALL, query);
      return response.data;
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to fetch vendor tag mappings"));
    }
  }
);

export const createVendorTagMapping = createAsyncThunk(
  "vendorTagMapping/create",
  async ({ sourceTagId, targetTagId }, { rejectWithValue }) => {
    try {
      const response = await post(
        API_ENDPOINTS.TAG_MAPPINGS.CREATE,
        {
          sourceTagId: String(sourceTagId),
          targetTagId: String(targetTagId),
          mappingType: VENDOR_MAPPING,
        },
        {},
        "json",
        { skipToast: true, suppressGlobalErrorModal: true }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to create vendor tag mapping"));
    }
  }
);

/**
 * PATCH /tag-mappings/:id — body: { sourceTagId, targetTagId } (and optionally isActive).
 */
export const updateVendorTagMappingApi = createAsyncThunk(
  "vendorTagMapping/update",
  async ({ id, sourceTagId, targetTagId, isActive }, { rejectWithValue }) => {
    try {
      const body = {};
      if (sourceTagId != null && String(sourceTagId).trim() !== "") {
        body.sourceTagId = String(sourceTagId).trim();
      }
      if (targetTagId != null && String(targetTagId).trim() !== "") {
        body.targetTagId = String(targetTagId).trim();
      }
      if (isActive !== undefined && isActive !== null) {
        body.isActive = Boolean(isActive);
      }
      if (Object.keys(body).length === 0) {
        return rejectWithValue("Nothing to update");
      }
      const response = await patch(
        API_ENDPOINTS.TAG_MAPPINGS.UPDATE(id),
        body,
        {},
        {},
        {
          skipToast: true,
          suppressGlobalErrorModal: true,
        }
      );
      return { id, data: response.data };
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to update vendor tag mapping"));
    }
  }
);

export const deleteVendorTagMappingApi = createAsyncThunk(
  "vendorTagMapping/delete",
  async (id, { rejectWithValue }) => {
    try {
      await del(API_ENDPOINTS.TAG_MAPPINGS.DELETE(id), {}, { skipToast: true });
      return id;
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to delete vendor tag mapping"));
    }
  }
);
